import { useEffect } from 'react';

import {
    PlayerAPI,
    PlayerEvent,
    PlayerEventCallback,
} from 'bitmovin-player/modules/bitmovinplayer-core';

function useEventHandler(
    player: PlayerAPI | null,
    event: PlayerEvent,
    handler: PlayerEventCallback | undefined,
) {
    useEffect(() => {
        if (player && handler) {
            player.on(event, handler);
        }

        return () => {
            if (player && handler) {
                player.off(event, handler);
            }
        };
    }, [player, event, handler]);
}

export default useEventHandler;
